// This file was auto-generated by querybuilder/Apollo and should not be edited.

import * as ExtendedFormFieldErrors from './ExtendedFormFieldErrors';
import { CustomIssuesCustomIssueFormFormSetInput } from './globalTypes';
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { IssueAreaV2Input, CustomIssueArea } from "./globalTypes";

// ====================================================
// GraphQL mutation operation: IssueAreaV2Mutation
// ====================================================

export interface IssueAreaV2Mutation_output_errors_extendedMessages {
  /**
   * A human-readable validation error.
   */
  message: string;
  /**
   * A machine-readable representation of the error.
   */
  code: string | null;
}

export interface IssueAreaV2Mutation_output_errors {
  /**
   * The camel-cased name of the input field, or '__all__' for non-field errors.
   */
  field: string;
  /**
   * A list of validation errors with extended metadata.
   */
  extendedMessages: IssueAreaV2Mutation_output_errors_extendedMessages[];
}

export interface IssueAreaV2Mutation_output_session_customIssuesV2 {
  id: string;
  /**
   * The area this custom issue belongs to.
   */
  area: CustomIssueArea;
  /**
   * The description of this custom issue.
   */
  description: string;
}

export interface IssueAreaV2Mutation_output_session {
  issues: string[];
  customIssuesV2: IssueAreaV2Mutation_output_session_customIssuesV2[] | null;
}

export interface IssueAreaV2Mutation_output {
  /**
   * A list of validation errors in the form, if any. If the form was valid, this list will be empty.
   */
  errors: IssueAreaV2Mutation_output_errors[];
  session: IssueAreaV2Mutation_output_session | null;
}

export interface IssueAreaV2Mutation {
  output: IssueAreaV2Mutation_output;
}

export interface IssueAreaV2MutationVariables {
  input: IssueAreaV2Input;
}

export const BlankIssueAreaV2Input: IssueAreaV2Input = {
  "area": "",
  "issues": [],
  "customIssues": []
};


export const BlankCustomIssuesCustomIssueFormFormSetInput: CustomIssuesCustomIssueFormFormSetInput = {
  "description": "",
  "DELETE": false
};

export const IssueAreaV2Mutation = {
  // The following query was taken from IssueAreaV2Mutation.graphql.
  graphQL: `# This file was auto-generated by querybuilder, please do not edit it.
mutation IssueAreaV2Mutation($input: IssueAreaV2Input!) {
  output: issueAreaV2(input: $input) {
    errors { ...ExtendedFormFieldErrors },
    session {
      issues,
      customIssuesV2 {
        id,
        area,
        description
      }
    }
  }
}
${ExtendedFormFieldErrors.graphQL}`,
  name: "IssueAreaV2Mutation",
  fetch(fetchGraphQL: (query: string, args?: any) => Promise<any>, args: IssueAreaV2MutationVariables): Promise<IssueAreaV2Mutation> {
    return fetchGraphQL(IssueAreaV2Mutation.graphQL, args);
  },
  blankInput: BlankIssueAreaV2Input,
};

export const fetchIssueAreaV2Mutation = IssueAreaV2Mutation.fetch;